import axios from "axios";

export const api = axios.create({
  baseURL: "https://api.erpsaude.com.br/v2",
})
